import { render, staticRenderFns } from "./RegistrationLayout.vue?vue&type=template&id=89998334&scoped=true&"
import script from "./RegistrationLayout.vue?vue&type=script&lang=ts&"
export * from "./RegistrationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationLayout.vue?vue&type=style&index=0&id=89998334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89998334",
  null
  
)

export default component.exports